import { IChartEventBadgeProps } from '../utils'
import { getChartEventEarningSvgString } from './earnings'

export function getChartEventEarningsNeutralSvgString(args: IChartEventBadgeProps) {
  return getChartEventEarningSvgString({ ...args, isFuture: false })
}
